export default __webpack_public_path__ + "static/SR France - Fiche de Données Sécurité - Burnt Sugar (Liquide)-e41928981a9c1bc9b537edf506c2b5f8.pdf";